import {Component, Input, OnInit} from '@angular/core';
import {ILayoutSettings, ILayoutSettingsComp} from '@app/feature/store-editor/components/layout/store-editor.interface';
import {MessageService} from '@app/shared/services/common/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PopupService} from '@app/shared/services/popup/popup.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() header: ILayoutSettingsComp;
  @Input() layoutSetting: ILayoutSettings;
  @Input() executeLogic = false;
  user = {
    ProfileImage: 'assets/img/default_user_img.png',
    FullName: '',
    userRole: '',
    CartItemCount: 0,
    isLoggedIn: false
  };

  storeUrl: string;
  CanEndUserCustomize = localStorage.getItem('canEndUserCustomize');

  constructor(private popupService: PopupService, private messageService: MessageService,
    private router: Router, private activatedRoute: ActivatedRoute) {

    this.activatedRoute.params.subscribe(params => {
      if (params['storename']) {
        this.storeUrl = params['storename'];
      }
    });
  }

  goTo(link: any) {
    if (this.executeLogic) {
      this.router.navigate(link);
    }
  }

  ngOnInit() {
    if (this.executeLogic) {
      this.subToService();
      this.initUser();
    }
  }

  openLoginDialog(): void {
    this.popupService.openLogin(true);
  }

  subToService() {
    this.messageService.getCartCount().subscribe(res => {
      this.user.CartItemCount = res.message['cartItemCount'];
      localStorage.setItem('cartItemCount', this.user.CartItemCount.toString());
    });


    // used for show profile image and name in header for end user
    this.messageService.getMessage().subscribe(message => {
      this.user.ProfileImage = message.message['profileImage'];
      this.user.FullName = message.message['profileName'];
      this.user.userRole = message.message['userRole'];
      this.user.CartItemCount = message.message['cartItemCount'];
      this.CanEndUserCustomize = message.message['canEndUserCustomize'];
      localStorage.setItem('cartItemCount', this.user.CartItemCount.toString());
      if (this.user.userRole) {
        this.user.isLoggedIn = true;
      } else {
        this.user.isLoggedIn = false;
      }
    });
  }

  initDefaultUser() {
    this.user = {
      ProfileImage: 'assets/img/default_user_img.png',
      FullName: '',
      userRole: '',
      CartItemCount: 0,
      isLoggedIn: false
    };
  }
  initUser() {

    this.user = {
      ProfileImage: localStorage.getItem('profileImage') !== 'null' ? localStorage.getItem('profileImage') : 'assets/img/default_user_img.png',
      FullName: localStorage.getItem('profileName'),
      userRole: localStorage.getItem('role'),
      CartItemCount: Number(localStorage.getItem('cartItemCount')),
      isLoggedIn: localStorage.getItem('role') === 'EndUser'
    };
    this.CanEndUserCustomize = localStorage.getItem('canEndUserCustomize');
  }

  logout() {
    const localStorageData = {
      storeId: localStorage.getItem('storeId'),
      storeName: localStorage.getItem('storeName'),
      storeUrl: localStorage.getItem('storeUrl'),
      canEndUserCustomize: localStorage.getItem('canEndUserCustomize'),
    };
    localStorage.clear();
    // tslint:disable-next-line:forin
    for (const i in localStorageData) {
      // @ts-ignore
      window.localStorage.setItem(i, localStorageData[i]);
    }
    // set defalut profile image  and name -------------------
    this.initDefaultUser();
    // --------------------------------------------------------
    this.router.navigate(['/', localStorageData.storeUrl]);
  }
}
